export const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://us-east1-test-project-88edd.cloudfunctions.net/api"
    : "http://localhost:5001/test-project-88edd/us-east1/api";

// Generic API methods
export const fetchData = async (endpoint) => {
  console.log("fetching data from:", `${API_URL}/${endpoint}`);
  const response = await fetch(`${API_URL}/${endpoint}`, {
    credentials: "include",
  });
  return response.json();
};

export const postData = async (endpoint, data, options = {}) => {
  try {
    const url = `${API_URL}/${endpoint}`;
    console.log("Making POST request:", {
      url,
      endpoint,
      data,
      options,
      fullUrl: `${API_URL}/${endpoint}`,
      environment: process.env.NODE_ENV,
    });

    // Determine if we're sending FormData
    const isFormData = data instanceof FormData;

    const headers = {
      ...options.headers,
    };

    // Only set Content-Type if not FormData
    // For FormData, let the browser set the correct Content-Type with boundary
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
    }

    console.log("Request headers:", headers);

    const response = await fetch(url, {
      method: "POST",
      headers,
      credentials: "include",
      body: isFormData ? data : JSON.stringify(data),
      ...options,
    });

    console.log("Response received:", {
      status: response.status,
      statusText: response.statusText,
      headers: Object.fromEntries(response.headers.entries()),
      ok: response.ok,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error("Error response data:", errorData);
      throw new Error(
        `HTTP error! status: ${response.status}, message: ${errorData.message || response.statusText}`
      );
    }

    const responseData = await response.json();
    console.log("Response data:", responseData);
    return responseData;
  } catch (error) {
    console.error("API request failed:", error);
    // Check if the error is due to an aborted request
    if (error.name === "AbortError" || error.message.includes("aborted")) {
      throw new Error(
        "Network request was aborted. Please check your connection and try again."
      );
    }
    throw error;
  }
};

// Then add specific API methods that use these generic ones
